<div class="agent-chat" [class.agent-chat--open]="isOpen()" [class.agent-chat--docked]="isDocked()">

  @if (isDocked()) {
    <div class="agent-chat__resize-handle" (mousedown)="onResizeStart($event)"></div>
  }

  <!-- Panel -->
  <div class="agent-chat__panel"
       role="dialog"
       aria-label="AI Agent Chat"
       [style.width]="isDocked() ? panelWidth() + 'px' : null">

    <div class="agent-chat__header">
      <div class="agent-chat__header-title">
        <i class="pi pi-sparkles"></i>
        <span>WellView Agent</span>
      </div>
      <div class="agent-chat__header-actions">
        <button
          type="button"
          class="agent-chat__icon-btn"
          [class.agent-chat__icon-btn--active]="isDocked()"
          title="Dock to side"
          (click)="setDocked(true)">
          <i class="pi pi-objects-column"></i>
        </button>
        <button
          type="button"
          class="agent-chat__icon-btn"
          [class.agent-chat__icon-btn--active]="!isDocked()"
          title="Float"
          (click)="setDocked(false)">
          <i class="pi pi-window-maximize"></i>
        </button>
        <button
          type="button"
          class="agent-chat__icon-btn"
          title="New conversation"
          (click)="clearConversation()">
          <i class="pi pi-refresh"></i>
        </button>
        <button
          type="button"
          class="agent-chat__icon-btn"
          title="Close"
          (click)="togglePanel()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Messages -->
    <div class="agent-chat__messages" #messagesContainer>
      @if (messages().length === 0) {
        <div class="agent-chat__empty">
          <i class="pi pi-comments agent-chat__empty-icon"></i>
          <p>Ask the WellView Agent anything about your well operations, NPT, HSE incidents, or performance metrics.</p>
        </div>
      }

      @for (msg of messages(); track $index) {
        <div class="agent-chat__message" [class.agent-chat__message--user]="msg.role === 'user'" [class.agent-chat__message--agent]="msg.role === 'agent'">
          <div class="agent-chat__message-bubble">
            @if (msg.role === 'agent' && msg.renderedHtml) {
              <div class="agent-chat__markdown" [innerHTML]="msg.renderedHtml"></div>
            } @else {
              <span>{{ msg.text }}</span>
            }
          </div>
          <div class="agent-chat__message-time">{{ msg.timestamp | date:'HH:mm' }}</div>
        </div>
      }

      @if (isLoading()) {
        <div class="agent-chat__message agent-chat__message--agent">
          <div class="agent-chat__message-bubble agent-chat__message-bubble--loading">
            <span class="agent-chat__dot"></span>
            <span class="agent-chat__dot"></span>
            <span class="agent-chat__dot"></span>
          </div>
        </div>
      }
    </div>

    <!-- Input -->
    <div class="agent-chat__input-area">
      <textarea
        class="agent-chat__input"
        rows="1"
        placeholder="Ask a question…"
        [value]="inputText()"
        (input)="onInputChange($any($event.target).value)"
        (keydown)="onKeyDown($event)"
        [disabled]="isLoading()"
        aria-label="Message input">
      </textarea>
      <button
        type="button"
        class="agent-chat__send"
        [disabled]="!inputText().trim() || isLoading()"
        (click)="sendMessage()"
        aria-label="Send message">
        <i class="pi pi-send"></i>
      </button>
    </div>

  </div>

  <!-- FAB toggle -->
  <button
    type="button"
    class="agent-chat__fab"
    (click)="togglePanel()"
    [attr.aria-label]="isOpen() ? 'Close AI Agent' : 'Open AI Agent'">
    <i class="pi" [class.pi-comments]="!isOpen()" [class.pi-times]="isOpen()"></i>
  </button>

</div>
